import ActionTypes from "../../../constants/ActionTypes";
import { ISetLanguageAction, ILanguageState } from "./types";

export function setActiveLanguage(activeLanguage: ILanguageState): ISetLanguageAction {
  return {
    type: ActionTypes.LANGUAGE.SET,
    payload: activeLanguage,
  };
}

export function changeLanguage(language: object) {
  return {
    type: ActionTypes.LANGUAGE.CHANGE,
    payload: language,
  };
}
